"use strict";

$(window).on('load',function () { 
  console.log('jQuery Page Loaded.');  
  setCurrentSide();
  checkSide();
});

// サイドメニュー高さ調整 
function checkSide(){
  var scrollValue = $(window).scrollTop();
  if(scrollValue > 120) {
    // $('.bl_book_side').css('height','calc(100vh - 120px)');
    $('.bl_book_side').addClass('js-scroll-height');
  } else {
    // $('.bl_book_side').css('height','calc(100vh - 290px)');
    $('.bl_book_side').removeClass('js-scroll-height');
  }
}

// サイドメニューカレント表示
function setCurrentSide(){
  // $('.bl_sideMenu .current').removeClass('current');
  // $('.bl_sideMenu .menu_itemParent a,.bl_sideMenu__intbank .menu_itemParent a,.bl_sideMenu__webfb .menu_itemParent a,.bl_sideMenu__densai .menu_itemParent a').filter(function(){return $(this).prop('href')==location.href;}).parent().addClass('current');
  // $('.bl_sideMenu .menu_itemParent > a,.bl_sideMenu__intbank .menu_itemParent > a,.bl_sideMenu__webfb .menu_itemParent > a,.bl_sideMenu__densai .menu_itemParent > a').each(function(){
  $('.bl_book_side ul li > a').each(function(){
    var wkTarget = $(this).prop('href');
    var wkLocation =location.href;
    wkTarget = wkTarget.replace(/#.*$/,"");
    wkLocation = wkLocation.replace(/#.*$/,"");
    wkTarget = wkTarget.replace(/index.html.*$/,"");
    wkLocation = wkLocation.replace(/index.html.*$/,"");
    wkTarget = wkTarget.replace(/index.php.*$/,"");
    wkLocation = wkLocation.replace(/index.php.*$/,"");
    // if(location.href === wkTarget){
    if(wkLocation === wkTarget){
      // console.log(wkTarget);
      $(this).parent().addClass('current');
      $(this).parents('.menu_itemParent').children('.toggle-submenu').addClass('open');
      $(this).parents('.menu_itemParent').children('.toggle-submenu').removeClass('close');
    }
  });
}

$(function () {
  //読み込みが完了
  $('.el_btnClose').on('click',function(){
    $(this).toggleClass('js_open');
    $('.bl_book').toggleClass('js_open');
  });
  
  $('.bl_sideMenu a[href]').on('click',function(){
    $('.el_btnClose').removeClass('js_open');
    $('.bl_book').removeClass('js_open');
  });
  
  $('.el_btnTop').on('click',function(){
    $('body, html').animate({ scrollTop: 0 }, 100);
  });

  $('.toggle-submenu').on('click',function(){
    if($(this).hasClass('open')){
      $(this).toggleClass('close');
      $(this).toggleClass('open');
    }else{
      $('.toggle-submenu').removeClass('open');
      $('.toggle-submenu').addClass('close');
      $(this).toggleClass('close');
      $(this).toggleClass('open');
    }
  });

});

// スクロール時
$(window).scroll(function(){
  checkSide();
});

// DOM読み込み完了
document.addEventListener('DOMContentLoaded', function(e) {
  console.log('DOM Content Loaded.');

  var menubtn = document.querySelectorAll('.btn-menu')[0];
  var menu = document.querySelectorAll('.site-menu .menu')[0];
  
  // var menuParent = document.getElementsByClassName('menu-item-has-children');
  // for( var i = 0; i < menuParent.length; i++ ) {
  //   menuParent[i].insertAdjacentHTML('afterbegin','<div class="toggle-submenu close"></div>');
  // }

  // var spmenubtn = document.querySelectorAll('.toggle-submenu');
  // var spmenubtn = document.getElementsByClassName('toggle-submenu');
  // for (let i = 0; i < spmenubtn.length; i++) {
  //   // fuga[i]で現在の要素を指定
  //   spmenubtn[i].addEventListener('click', function() {
  //     spmenubtn[i].classList.toggle('close');
  //     spmenubtn[i].classList.toggle('open');
  //   }, false);
  // }

  var state = false;
  var scrollpos;
  var menuIcon = document.getElementById('menu-icon');
  var menuBackground = document.getElementById('menu-background');
  var body = document.querySelectorAll('body')[0];

  function scrollStop() {
    if(state == false) {
      scrollpos = window.scrollY;
      body.classList.add('js-fixed');
      body.style.top = -scrollpos + 'px';
      // $('body').addClass('js-fixed').css({'top': -scrollpos});
      state = true;
    } else {
      body.classList.remove('js-fixed');
      body.style.top = 0;
      // $('body').removeClass('js-fixed').css({'top': 0});
      window.scrollTo( 0 , scrollpos );
      state = false;
    }
  }

  menuIcon.addEventListener('click',scrollStop);
  menuBackground.addEventListener('click',scrollStop);

}, false);

// 完全に読み込み完了
window.addEventListener('load', function() {
  console.log('Page Loaded.');
});
